import { useQuery } from "@apollo/client";

/**
 * コンポーネントが描画されたらクエリ実行
 * @param {Object} gql
 * @returns
 */
const useGetQuery = (gql, $input, fetchPolicy = "cache-first") => {

  const { loading, error, data } = useQuery(gql, {
    fetchPolicy: fetchPolicy,
    variables: { input: $input },
  });

  return [data, error, loading];
};

export default useGetQuery;
